module.exports = __webpack_public_path__ + "static/Profile-Justin_v1-2dc37f0d9057899771cf5962b86bb15e.svg";